<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6>Plant Performance</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list class="site-info-list">
        <mat-list-item> 
          Plant Start Time: <span class="item-value"> &nbsp; {{ plantStartTime | date:"yyyy-MM-dd hh:mm:ss" }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          Operating Hours: <span class="item-value"> &nbsp; {{ operatingHours }} Hours</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
            Plant Stop Time: <span class="item-value"> &nbsp; {{ plantStopTime | date:"yyyy-MM-dd hh:mm:ss" }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
              PR (Today cumulative): <span class="item-value"> &nbsp; {{ performanceRatioOneday }}</span>
          </mat-list-item>
            
      </mat-list>
  </mat-expansion-panel>